"use client";

import { CheckCircle, HelpCircle, Search } from "lucide-react";

export default function ConfidenceBadge({ confidence }) {
  const configs = {
    high: { color: "bg-green-100 text-green-800 border-green-200", label: "High Confidence", icon: <CheckCircle className="h-3 w-3" /> },
    "medium-high": { color: "bg-blue-100 text-blue-800 border-blue-200", label: "Good Match", icon: <CheckCircle className="h-3 w-3" /> },
    medium: { color: "bg-yellow-100 text-yellow-800 border-yellow-200", label: "Possible Match", icon: <HelpCircle className="h-3 w-3" /> },
    low: { color: "bg-orange-100 text-orange-800 border-orange-200", label: "Related Info", icon: <HelpCircle className="h-3 w-3" /> },
    none: { color: "bg-gray-100 text-gray-800 border-gray-200", label: "Suggestions", icon: <Search className="h-3 w-3" /> },
  };

  const config = configs[confidence] || configs.none;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${config.color}`}>
      {config.icon}
      {config.label}
    </span>
  );
}
